import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e17c9f2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-container" }
const _hoisted_2 = { class: "track-overlay" }
const _hoisted_3 = { class: "microphone-notify-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, null, -1))
const _hoisted_5 = { class: "w-9/12 lg:w-6/12" }
const _hoisted_6 = { class: "text-off" }
const _hoisted_7 = {
  key: 1,
  class: "microphone-notify active"
}
const _hoisted_8 = { class: "text-off" }
const _hoisted_9 = { class: "w-full flex justify-end text-white" }
const _hoisted_10 = { class: "camera-notify" }
const _hoisted_11 = {
  key: 0,
  class: "text-off"
}
const _hoisted_12 = {
  key: 1,
  class: "text-off"
}
const _hoisted_13 = {
  key: 0,
  class: "video-button"
}
const _hoisted_14 = {
  key: 1,
  class: "media-block"
}
const _hoisted_15 = { class: "icon-container" }
const _hoisted_16 = {
  key: 3,
  class: "media-block"
}
const _hoisted_17 = { class: "icon-container" }

import ControlButton from '@/components/room/ControlButton.vue'
import { useElementSize } from '@vueuse/core'
import { computed, ref } from 'vue'
const VIDEO_RATIO = 9 / 16


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewWrapper',
  props: {
  isReady: {
    type: Boolean,
    default: false,
  },
  isProcessing: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  // video
  cameraEnabled: {
    type: Boolean,
    default: false,
  },
  isCameraFound: {
    type: Boolean,
    default: false,
  },
  allowedCamera: {
    type: Boolean,
    default: false,
  },
  // audio
  microphoneEnabled: {
    type: Boolean,
    default: false,
  },
  isMicrophoneFound: {
    type: Boolean,
    default: false,
  },
  allowedMicrophone: {
    type: Boolean,
    default: false,
  },
  width: {
    type: String,
    default: '100%', // allow percent or px
  },
  canSetBackground: {
    type: Boolean,
    default: false,
  },
  canOpenSetting: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  'toggle-camera',
  'toggle-microphone',
  'open-background-setting',
  'open-setting',
],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "d495d66c": (widthPixel.value),
  "714fca75": (heightPixel.value)
}))

const props = __props
function toDecimal(percent: string) {
  const parsed = parseFloat(percent)
  if (!Number.isNaN(parsed)) {
    return parseFloat(percent) / 100
  } else {
    return 0
  }
}

const emit = __emit
const previewRef = ref<HTMLElement | null>(null)
const { width: wrapperWidth } = useElementSize(previewRef)
const calculateWidth = computed(() =>
  props.width.includes('%')
    ? wrapperWidth.value * toDecimal(props.width)
    : props.width.includes('px')
    ? Number(props.width.replace('px', ''))
    : wrapperWidth.value,
)
const calculateHeight = computed(() => calculateWidth.value * VIDEO_RATIO)

const widthPixel = computed(() => `${calculateWidth.value}px`)
const heightPixel = computed(() => `${calculateHeight.value}px`)

const toggleCamera = () => {
  if (props.isProcessing) return
  emit('toggle-camera')
}
const toggleMicrophone = () => {
  if (props.isProcessing) return
  emit('toggle-microphone')
}
const clickBackgroundButton = () => {
  emit('open-background-setting')
}
const clickSettingButton = () => {
  emit('open-setting')
}

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "previewRef",
    ref: previewRef,
    class: "preview-wrapper"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (__props.isMicrophoneFound && __props.allowedMicrophone && __props.isReady)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["microphone-notify", { active: !__props.microphoneEnabled }])
                }, [
                  _createVNode(_component_SvgIcon, {
                    class: "mr-2",
                    icon: "mic-disabled",
                    "inherit-fill": true,
                    height: "16"
                  }),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('microphone-off')), 1)
                ], 2))
              : _createCommentVNode("", true),
            ((!__props.isMicrophoneFound || !__props.allowedMicrophone) && __props.isReady)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_SvgIcon, {
                    class: "mr-2",
                    icon: "mic-disabled",
                    "inherit-fill": true,
                    height: "16"
                  }),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('no-microphone-found')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (__props.canOpenSetting)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "dots-container h-8 w-8 cursor-pointer rounded-full btn-bg-color",
                  onClick: clickSettingButton
                }, [
                  _createVNode(_component_SvgIcon, {
                    class: "h-4 w-4",
                    icon: "three-dots",
                    "inherit-fill": true,
                    height: "16"
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (!__props.cameraEnabled && __props.isCameraFound && __props.allowedCamera)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('camera-off')), 1))
            : (!__props.isCameraFound || !__props.allowedCamera)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('no-camera-found')), 1))
              : _createCommentVNode("", true)
        ]),
        (__props.isReady)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (__props.isCameraFound && __props.allowedCamera)
                ? (_openBlock(), _createBlock(ControlButton, {
                    key: 0,
                    disabled: !__props.cameraEnabled,
                    icon: "cam",
                    height: "18",
                    "icon-disabled": "cam-disabled",
                    class: _normalizeClass(["control-btn w-9 h-9", [__props.isProcessing && 'btn-disabled']]),
                    onClick: toggleCamera
                  }, null, 8, ["disabled", "class"]))
                : _createCommentVNode("", true),
              (!__props.isCameraFound || !__props.allowedCamera)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(ControlButton, {
                      disabled: true,
                      icon: "cam",
                      height: "18",
                      "icon-disabled": "cam-disabled",
                      class: "control-btn w-9 h-9"
                    }),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_SvgIcon, {
                        class: "control-icon",
                        icon: "warning",
                        "inherit-fill": true,
                        height: "8"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (__props.isMicrophoneFound && __props.allowedMicrophone)
                ? (_openBlock(), _createBlock(ControlButton, {
                    key: 2,
                    disabled: !__props.microphoneEnabled,
                    icon: "mic",
                    height: "18",
                    "icon-disabled": "mic-disabled",
                    class: _normalizeClass(["control-btn w-9 h-9", [__props.isProcessing && 'btn-disabled']]),
                    onClick: toggleMicrophone
                  }, null, 8, ["disabled", "class"]))
                : _createCommentVNode("", true),
              (!__props.isMicrophoneFound || !__props.allowedMicrophone)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(ControlButton, {
                      disabled: true,
                      icon: "mic",
                      height: "18",
                      "icon-disabled": "mic-disabled",
                      class: "control-btn w-9 h-9"
                    }),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_SvgIcon, {
                        class: "control-icon",
                        icon: "warning",
                        "inherit-fill": true,
                        height: "8",
                        onClick: toggleMicrophone
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}
}

})